import { Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '../components/feedback/empty-state.js';
import { Button } from '@tailoring-crm/ui';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon={SearchX}
      title={t('notFound.title')}
      description={t('notFound.description')}
      action={
        <Button asChild>
          <Link to="/">{t('notFound.goHome')}</Link>
        </Button>
      }
    />
  );
}

export default NotFoundPage;
